.hero {
  position: relative;
  /* Fluid hero — generous on desktop, calm on phones. Lets short
     landscape viewports keep some content below the fold. */
  min-height: clamp(280px, 60vh, 560px);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.9) contrast(1.1);
  opacity: 0.92;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.15));
}

.content {
  position: relative;
  z-index: 1;
  color: #fff;
  text-align: center;
  padding: var(--space-7) var(--space-6);
  max-width: 720px;
}

.kicker {
  text-transform: uppercase;
  letter-spacing: 0.4em;
  font-size: 0.7rem;
  margin-bottom: var(--space-3);
  opacity: 0.85;
}

.title {
  font-family: var(--font-display);
  font-size: var(--fs-3xl);
  margin: 0 0 var(--space-3);
  line-height: 1.05;
}

.subtitle {
  margin: 0 0 var(--space-5);
  font-size: var(--fs-base);
  color: rgba(255, 255, 255, 0.85);
  font-weight: 600;
}
